export const status_choices = [
				{ value: 'In afwachting van goedkeuring' },
				{ value: 'Informatie van klant benodigd' },
				{ value: 'In afwachting van plaatsing' },
				{ value: 'Goedgekeurd & geplaatst' },
				{ value: 'Afgekeurd: onvoldoende relevantie' }
			];

export const FieldTypes = [
				{ value: 'TEXT' },
				{ value: 'YESNO' },
			];


// WEBPACK FOOTER //
// ./src/utils/enums.js